import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { Badge } from "./badge";
import { QuestionRow } from "./question_row";

// A Drafting section in the left pane: its name asks for it (unless his own,
// with no `onAsk`), its sources, status and ··· menu beside it, its line under
// it, after what he has to act on in rose (`alert`). `tag` follows the name
// ("Edited by you"), as does Waiting; `flag` sits under the row.
export const SectionRow: FC<{
  name: string;
  tag?: string;
  waiting?: boolean;
  line?: string | null;
  alert?: string | null;
  disabled?: boolean;
  onAsk?(): void;
  sources: ReactNode;
  status: ReactNode;
  menu: ReactNode;
  flag?: ReactNode;
}> = ({
  name,
  tag,
  waiting,
  line,
  alert,
  disabled,
  onAsk,
  sources,
  status,
  menu,
  flag,
}) => {
  const label = (
    <>
      {name}
      {tag && <span className="text-slate-400"> · {tag}</span>}
      {waiting && (
        <span className="ml-2 align-middle">
          <Badge pill color="amber" variant="outlined">
            Waiting
          </Badge>
        </span>
      )}
      {(alert || line) && (
        <span
          title={[alert, line].filter(Boolean).join(" · ")}
          className="block truncate text-[11.5px] text-slate-500"
        >
          {alert && <span className="text-rose-700">{alert}</span>}
          {alert && line && " · "}
          {line}
        </span>
      )}
    </>
  );

  return (
    // The whole row tints on hover, its controls with its name.
    <div className={clsx(onAsk && "hover:bg-violet-50")}>
      <div className="flex items-start">
        {onAsk ? (
          <QuestionRow
            onClick={onAsk}
            disabled={disabled}
            arrow={false}
            sparkle={false}
          >
            {label}
          </QuestionRow>
        ) : (
          <div className="min-w-0 flex-1 px-3 py-2 text-[12.5px] leading-[1.45] text-slate-700">
            {label}
          </div>
        )}
        <div className="flex shrink-0 items-center gap-1.5 py-1.5 pr-2">
          {sources}
          {status}
          {menu}
        </div>
      </div>
      {flag}
    </div>
  );
};
